// React component for the missing locaion field alert
import React from 'react';
import Alert from '@mui/material/Alert';
import InfoIcon from '@mui/icons-material/Info';
import Typography from '@mui/material/Typography';

const MissingAlert = (): JSX.Element => {
  return (
    <Alert
      severity="success"
      variant="outlined"
      icon={<InfoIcon sx={{ color: '#9CA3AF' }} />}
      sx={{
        backgroundColor: '#F3F4F6',
        border: '1px solid #E5E7EB',
        padding: '4px 13px',
        borderRadius: '6px',
        marginBottom: '20px'
      }}
    >
      <Typography fontSize="14px" fontWeight="400" color="#1F2937">
        Fill missing fields to ensure accurate geo mapping
      </Typography>
    </Alert>
  );
};

export default MissingAlert;
